import { GridCellProps } from '@progress/kendo-react-grid';
import { useInternationalization } from '@progress/kendo-react-intl';
import { useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { getPriceCurrencyFormat } from 'src/utils/price';
import { useContextSelector } from 'use-context-selector';
import { ViewCatalogProductsContext } from '../ViewCatalogProductsContext';

const PriceCell = (props: GridCellProps) => {
  const intl = useInternationalization();
  const { value } = useGridCellDisplayValue(props);
  const priceFormat = useMemo(
    () => getPriceCurrencyFormat(props.dataItem?.uom),
    [props.dataItem?.uom]
  );
  const formattedPrice = intl.format(priceFormat, Number(value));
  const selectedCatalog = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.selectedCatalog
  );
  const isExternalSupplier = !!(selectedCatalog && selectedCatalog?.catalogType === 2);
  return (
    <GridCellBase
      {...props}
      rowSelectionEnabled={isExternalSupplier ? false : true}
      className="!p-0 !text-right"
      title={formattedPrice}
    >
      {formattedPrice}
    </GridCellBase>
  );
};

export default PriceCell;
